module.exports = __webpack_public_path__ + "h5/img/santa_hat.e373a57b.gif";